import { z } from 'zod';

import { clientWithLeadSchema } from './ClientWithLeads';

export const clientWithLeadListSchema = z.object({
  items: z.array(clientWithLeadSchema),
  total: z.number(),
});

export type ClientWithLeadsListEntityApi = z.input<typeof clientWithLeadListSchema>;

export type ClientWithLeadsListEntity = z.infer<typeof clientWithLeadListSchema>;
